export default __webpack_public_path__ + "85909f47e8f5657ceadd1922b6c40c06.png";